import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useStore } from 'react-redux';
import CounterCard from '../../../../components/CounterCard';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn';
import PendingActionsIcon from '@material-ui/icons/Schedule';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';
import AdjustIcon from '@material-ui/icons/Adjust';

import { Grid } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  BOOKING: { backgroundColor: '#bbdefb', color: '#0d47a1' },
  PICKED: { backgroundColor: '#ffe0b2', color: '#e65100' },
  PENDING: { backgroundColor: '#fff9c4', color: '#f57f17' },
  ON_DELIVERY: { backgroundColor: '#ffeb3b', color: '#000' },
  DELIVERED: { backgroundColor: '#388e3c', color: '#fff' },
  PARTIALLY_DELIVERED: { backgroundColor: '#00bcd4', color: '#fff' },
  RETURNED: { backgroundColor: '#9c27b0', color: '#fff' },
  CUSTOMER_RETURN: { backgroundColor: '#cfd8dc', color: '#263238' },
});
export default function Dashboard() {
  const classes = useStyles();
  const store = useStore();

  const [get_table_data, set_table_data]: any = useState([]);
  async function fetchAPI() {
    const auth = {
      headers: {
        Authorization: `Bearer ${store.getState().auth.jwt}`,
      },
    };
    await Promise.all([
      axios.get(`${process.env.REACT_APP_API_SERVER}/parcels/count?status=BOOKING`, auth),
      axios.get(`${process.env.REACT_APP_API_SERVER}/parcels/count?status=PICKED`, auth),
      axios.get(`${process.env.REACT_APP_API_SERVER}/parcels/count?status=ON_DELIVERY`, auth),
      axios.get(
        `${process.env.REACT_APP_API_SERVER}/parcels/count?status_in=DELIVERED&status_in=DELIVERED_BY_RIDER`,
        auth,
      ),
      axios.get(`${process.env.REACT_APP_API_SERVER}/parcels/count?status=CANCEL`, auth),
      axios.get(
        `${process.env.REACT_APP_API_SERVER}/parcels/count?status_in=RETURNED&status_in=RETURNED_BY_RIDER`,
        auth,
      ),
      axios.get(`${process.env.REACT_APP_API_SERVER}/parcels/count?status=PENDING`, auth),
      axios.get(`${process.env.REACT_APP_API_SERVER}/parcels/count?status=CUSTOMER_RETURN`, auth),
      axios.get(
        `${process.env.REACT_APP_API_SERVER}/parcels/count?status_in=PARTIALLY_DELIVERED&status_in=PARTIALLY_DELIVERED_BY_RIDER`,
        auth,
      ),
    ]).then(
      ([BOOKING, PICKED, ON_DELIVERY, DELIVERED, CANCEL, RETURNED, PENDING, CUSTOMER_RETURN, PARTIALLY_DELIVERED]) => {
        set_table_data([
          {
            status: 'BOOKING',
            label: 'Booking',
            count: BOOKING.data,
            icon: <ShoppingCartIcon style={{ color: '#1976d2' }} />,
            link: '/dashboard/parcel?status_in=BOOKING',
          },
          {
            status: 'PICKED',
            label: 'Picked',
            count: PICKED.data,
            icon: <DirectionsRunIcon style={{ color: '#ff9800' }} />,
            link: '/dashboard/parcel?status_in=PICKED',
          },
          {
            status: 'PENDING',
            label: 'Pending',
            count: PENDING.data,
            icon: <PendingActionsIcon style={{ color: '#ffb300' }} />,
            link: '/dashboard/parcel?status_in=PENDING',
          },
          {
            status: 'ON_DELIVERY',
            label: 'On Delivery',
            count: ON_DELIVERY.data,
            icon: <LocalShippingIcon style={{ color: '#4caf50' }} />,
            link: '/dashboard/parcel?status_in=ON_DELIVERY',
          },
          {
            status: 'DELIVERED',
            label: 'Delivered',
            count: DELIVERED.data,
            icon: <CheckCircleIcon style={{ color: '#fff' }} />,
            link: '/dashboard/parcel?status_in=DELIVERED&status_in=DELIVERED_BY_RIDER',
          },
          {
            status: 'PARTIALLY_DELIVERED',
            label: 'Partially Delivered',
            count: PARTIALLY_DELIVERED.data,
            icon: <AdjustIcon style={{ color: '#fff' }} />,
            link: '/dashboard/parcel?status_in=PARTIALLY_DELIVERED&status_in=PARTIALLY_DELIVERED_BY_RIDER',
          },
          {
            status: 'RETURNED',
            label: 'Returned',
            count: RETURNED.data,
            icon: <AssignmentReturnIcon style={{ color: '#fff' }} />,
            link: '/dashboard/parcel?status_in=RETURNED&status_in=RETURNED_BY_RIDER',
          },
          {
            status: 'CUSTOMER_RETURN',
            label: 'Customer Return',
            count: CUSTOMER_RETURN.data,
            icon: <AssignmentReturnIcon style={{ color: '#607d8b' }} />,
            link: '/dashboard/parcel?status_in=CUSTOMER_RETURN',
          },
        ]);
      },
    );
  }
  useEffect(() => {
    fetchAPI();
  }, []);

  return (
    <Grid item xs={12} container spacing={1} className="pb-5" justifyContent="center" alignItems="center">
      {get_table_data.map((item: any) => {
        // Ensure status is a valid key for classes
        const statusKey = (item.status || '').toUpperCase();
        const className = (classes as Record<string, string>)[statusKey] || '';
        return (
          <Grid item xs={6} sm={4} md={3} key={item.status}>
            <CounterCard
              label={item.label}
              count={item.count}
              cardClassName={className}
              link={item?.link}
              key={item.status}
              icon={item.icon}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}
